export enum RouteStatusEnum {
  Active = 'Active',
  Inactive = 'Inactive',
}
